import { render, staticRenderFns } from "./ReadOnlyDocumentOption.vue?vue&type=template&id=46f958e6&"
import script from "./ReadOnlyDocumentOption.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyDocumentOption.vue?vue&type=script&lang=js&"
import style0 from "./ReadOnlyDocumentOption.vue?vue&type=style&index=0&id=46f958e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports